import type { ReactNode } from 'react'
import type { Editor } from '@tiptap/core'
import { useEditorState } from '@tiptap/react'
import { twMerge } from 'tailwind-merge'
import LinkIcon from 'shared/icons/link-icon'
import UnlinkIcon from 'shared/icons/unlink-icon'

type LinkButtonProps = {
  editor: Editor
  label: string
  onStartLinkEdit: () => void
}

export default function LinkButton({ editor, label, onStartLinkEdit }: LinkButtonProps): ReactNode {
  const active = useEditorState({
    editor,
    selector: ({ editor: ed }) => ed.isActive('link'),
  })

  return (
    <button
      className={twMerge(
        'relative z-10 inline-flex items-center px-2 py-1',
        active ? 'fill-black' : 'fill-text-secondary hover:fill-black',
      )}
      onMouseDown={event => {
        event.preventDefault()
        event.stopPropagation()
        if (!active) {
          onStartLinkEdit()
          return
        }
        editor.chain().focus().extendMarkRange('link').unsetLink().run()
      }}
      title={label}
      type="button"
    >
      {active ? <UnlinkIcon height="15px" /> : <LinkIcon height="15px" />}
    </button>
  )
}
